import { STATUS_COLORS } from '@/constants/statusColors';

import { FilterSection } from '../../OrderStatus/Table/utils';

export const historyStatusLabel = (status: string) => {
  switch (status) {
    case 'not_received':
      return 'No recibido';
    case 'received':
      return 'Recibido';
    case 'under_received':
      return 'Parcialmente recibido';
    case 'over_received':
      return 'Sobre recibido';
    case 'pending':
      return 'Pendiente';
    case 'closed':
      return 'Cerrada';
    case 'canceled':
      return 'Cancelada';
    case 'in_progress':
      return 'En progreso';
    default:
      return 'No recibido';
  }
};

export const getStatusStyle = (status: string, type: 'inventory' | 'order') => {
  const normalizedStatus = String(status)
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  if (type === 'inventory') {
    const inventoryStyles = {
      received: { color: STATUS_COLORS.green, bg: STATUS_COLORS.greenBg },
      not_received: { color: STATUS_COLORS.red, bg: STATUS_COLORS.redBg },
      over_received: { color: STATUS_COLORS.blue, bg: STATUS_COLORS.blueBg },
      default: { color: STATUS_COLORS.yellow, bg: STATUS_COLORS.yellowBg },
    };
    return (
      inventoryStyles[normalizedStatus as keyof typeof inventoryStyles] || inventoryStyles.default
    );
  }

  const orderStyles = {
    pending: { color: STATUS_COLORS.yellow, bg: STATUS_COLORS.yellowBg },
    closed: { color: STATUS_COLORS.green, bg: STATUS_COLORS.greenBg },
    completed: { color: STATUS_COLORS.green, bg: STATUS_COLORS.greenBg },
    finalized: { color: STATUS_COLORS.green, bg: STATUS_COLORS.greenBg },
    canceled: { color: STATUS_COLORS.red, bg: STATUS_COLORS.redBg },
    cancelled: { color: STATUS_COLORS.red, bg: STATUS_COLORS.redBg },
    in_progress: { color: STATUS_COLORS.lightBlue, bg: STATUS_COLORS.lightBlueBg },
    default: { color: STATUS_COLORS.gray, bg: STATUS_COLORS.grayBg },
  };

  return orderStyles[normalizedStatus as keyof typeof orderStyles] || orderStyles.default;
};

export const filters: FilterSection[] = [
  {
    width: '150px',
    filterName: 'inventoryStatus',
    items: [
      { value: 'not_received' },
      { value: 'received' },
      { value: 'under_received' },
      { value: 'over_received' },
    ],
  },
  {
    width: '150px',
    filterName: 'status',
    items: [
      { value: 'canceled' },
      { value: 'pending' },
      { value: 'closed' },
      { value: 'in_progress' },
    ],
  },
];
